import { connect } from "react-redux";
import CreateInvoiceDialog from "./CreateInvoiceDialog";
import { cancelCreateInvoice, patchEditInvoice } from "./actions/invoices";

const mapStateToProps = state => {
  let { open, data } = state.modalForm.createInvoice;
  return { open, data };
};
const mapDispatchToProps = dispatch => ({
  onSave() {
    let element = document.querySelector("#Invoice .print");
    if (typeof element === "object" && typeof element.click === "function") {
      element.click();
    }
  },
  onChange(patch) {
    dispatch(patchEditInvoice({ [patch.name]: patch.value }));
  },
  onCancel() {
    dispatch(cancelCreateInvoice());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(
  CreateInvoiceDialog
);



// WEBPACK FOOTER //
// ./src/CreateInvoiceDialogContainer.js